import { ProductTripAdvisorLine } from 'Components/lines/product-tripadvisor-line/ProductTripAdvisorLine';
export default ProductTripAdvisorLine;
